import React from 'react';
import { Paper, Table, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import UsersTableUserMap from './UsersTableUserMap';

const UsersTable = ({
  users,
  onEditUser,
  onDeleteUser,
  roleBasedOptions,
  isBuyer,
}) => {
  return (
    <TableContainer component={Paper} variant={'outlined'}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Username</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Phone Number</TableCell>
            {isBuyer && <TableCell>SMS</TableCell>}
            <TableCell>{/* Empty cell for actions column */}</TableCell>
          </TableRow>
        </TableHead>
        <UsersTableUserMap
          users={users}
          onEdit={onEditUser}
          onDelete={onDeleteUser}
          roleBasedOptions={roleBasedOptions}
          isBuyer={isBuyer}
        />
      </Table>
    </TableContainer>
  );
};

export default UsersTable;
